// Запросы к API портала: тот же адрес, cookie сеанса, JSON. Ошибка — ApiError с телом ответа в data,
// как у прежнего $fetch: интерфейс читает error.data.message и error.statusCode.
export type Query = Record<string, unknown>;
export interface RequestOptions {
  method?: string;
  body?: unknown;
  query?: Query;
  headers?: Record<string, string>;
  signal?: AbortSignal;
}

export class ApiError extends Error {
  readonly statusCode: number;
  readonly status: number;
  readonly statusMessage: string;
  readonly data: { statusCode?: number; message?: string } & Record<string, unknown>;
  constructor(status: number, data: ApiError['data']) {
    super(typeof data?.message === 'string' ? data.message : `Ошибка ${status}`);
    this.name = 'ApiError';
    this.statusCode = this.status = status;
    this.statusMessage = this.message;
    this.data = data ?? {};
  }
}

export function withQuery(url: string, query?: Query): string {
  if (!query) return url;
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    for (const item of Array.isArray(value) ? value : [value]) params.append(key, String(item));
  }
  const text = params.toString();
  return text ? `${url}${url.includes('?') ? '&' : '?'}${text}` : url;
}

export async function api<T = any>(url: string, options: RequestOptions = {}): Promise<T> {
  const method = (options.method ?? (options.body !== undefined ? 'POST' : 'GET')).toUpperCase();
  const headers: Record<string, string> = { accept: 'application/json', ...options.headers };
  let body: BodyInit | undefined;
  if (options.body instanceof FormData) body = options.body;
  else if (options.body !== undefined) { body = JSON.stringify(options.body); headers['content-type'] = 'application/json'; }
  else if (method !== 'GET' && method !== 'HEAD') { body = '{}'; headers['content-type'] = 'application/json'; }
  const response = await fetch(withQuery(url, options.query), { method, headers, body, credentials: 'same-origin', signal: options.signal });
  const text = await response.text();
  let data: unknown = text;
  if ((response.headers.get('content-type') ?? '').includes('json')) {
    try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  }
  if (!response.ok) throw new ApiError(response.status, (typeof data === 'object' && data) ? data as ApiError['data'] : { statusCode: response.status });
  return data as T;
}
